(function () {
  var ADDON_PRODUCT_ID = 7885252329537;

  function init(gate) {
    if (gate.dataset.textlyGateBound) return;
    gate.dataset.textlyGateBound = '1';

    function clearTextlyInputs() {
      var fields = gate.querySelectorAll('input, textarea');
      for (var i = 0; i < fields.length; i++) {
        var el = fields[i];
        if (el.type === 'file') {
          try { el.value = ''; } catch (_) {}
        } else if (el.tagName === 'TEXTAREA' || /^(text|email|number|tel|url|search)$/i.test(el.type)) {
          el.value = '';
        } else {
          continue;
        }
        el.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function applyState(selected) {
      if (gate.hidden === !selected) return;
      gate.hidden = !selected;
      if (!selected) clearTextlyInputs();
    }

    document.addEventListener('lbProductStateChange', function (e) {
      var d = e.detail || {};
      if (Number(d.targetProductId) !== ADDON_PRODUCT_ID) return;
      applyState(!!d.selected);
    }, true);
  }

  function boot() {
    var gates = document.querySelectorAll('[data-textly-gate]');
    for (var i = 0; i < gates.length; i++) init(gates[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
